import { serializeFiltersToQuery } from "./serializeFiltersToQuery";

/**
 * Builds a URL query string from a filter object.
 * Ensures that array parameters are serialized correctly (e.g., key[]=value1&key[]=value2).
 *
 * @param filters - The filter object.
 * @returns A URL query string.
 */
export function buildQueryStringFromFilters(
  filters: Record<string, any>,
): string {
  const querySource = serializeFiltersToQuery(filters); // serializeFiltersToQuery MUST return keys like 'city[]' for arrays
  const params = new URLSearchParams();

  Object.entries(querySource).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((v) => params.append(key, String(v))); // key is already, for example, 'city[]'
    } else if (value !== undefined && value !== null) {
      params.append(key, String(value));
    }
  });

  return params.toString();
}
